export const URLs = {
    Fornecedores: {
        urlVisualizacao: "fornecedores",
        urlCriacao: "fornecedores/cadastrar",
        permissao: "Fornecedores",
    },
    Colaboradores: {
        urlVisualizacao: "colaboradores",
        urlCriacao: "colaboradores/cadastrar",
        permissao: "Colaboradores",
    },
    GruposFornecedores: {
        urlVisualizacao: "grupo-fornecedores",
        urlCriacao: "grupo-fornecedores/cadastrar",
        permissao: "GruposFornecedores",
    },
    Ancoras: {
        urlVisualizacao: "ancoras",
        urlCriacao: "ancoras/cadastrar",
        permissao: "Ancoras",
    },
    CartoesPontos: {
        urlVisualizacao: "cartoes-ponto",
        urlCriacao: "cartoes-ponto/cadastrar",
        permissao: "CartoesPonto",
    },
    Plataformas: {
        urlVisualizacao: "plataformas",
        urlCriacao: "plataformas/cadastrar",
        permissao: "Plataformas",
    },
    ImportacoesTitulosApisErps: {
        urlVisualizacao: "erps",
        urlCriacao: "erp/cadastrar",
        permissao: "ImportacoesTitulosApisErps",
    },
    MonitorHangfire: {
        urlVisualizacao: "monitor-hangfire",
        urlCriacao: "monitor-hangfire",
        permissao: "MonitorHangfire",
    },
    DestinosPagamentos: {
        urlVisualizacao: "destinos-pagamentos",
        urlCriacao: "destinos-pagamentos/cadastrar",
        permissao: "DestinosPagamentos",
    },
    BancosRemessas: {
        urlVisualizacao: "bancos-remessas",
        urlCriacao: "bancos-remessas/cadastrar",
        permissao: "BancosRemessas",
    },
    PagamentosRemessas: {
        urlVisualizacao: "pagamentos-remessas",
        urlCriacao: "pagamentos-remessas/cadastrar",
        permissao: "PagamentosRemessas",
    },
    ConsultarRemessas: {
        urlVisualizacao: "consultar-remessas",
        urlCriacao: "consultar-remessas",
        permissao: "ConsultarRemessas",
    },
    AgendamentoRemessas: {
        urlVisualizacao: "agendamento-remessas",
        urlCriacao: "agendamento-remessas",
        permissao: "AgendamentoRemessas",
    },
    Relatorio001Producao: {
        urlVisualizacao: "relatorio/producao",
        urlCriacao: "relatorio/producao",
        permissao: "Relatorio001Producao",
    },
    Relatorio005ProducaoDiaria: {
        urlVisualizacao: "relatorio/producao/diaria",
        urlCriacao: "relatorio/producao/diaria",
        permissao: "Relatorio005ProducaoDiaria",
    },
    Relatorio002Metas: {
        urlVisualizacao: "relatorio/metas",
        urlCriacao: "relatorio/metas",
        permissao: "Relatorio002Metas",
    },
    Relatorio003Diario: {
        urlVisualizacao: "relatorios/diario",
        urlCriacao: "relatorios/diario",
        permissao: "Relatorio003Diario",
    },
    Relatorio004Mensal: {
        urlVisualizacao: "relatorios/mensal",
        urlCriacao: "relatorios/mensal",
        permissao: "Relatorio004Mensal",
    },
    Relatorio006ContasAPagar: {
        urlVisualizacao: "relatorio/contasAPagar",
        urlCriacao: "relatorios/contasAPagar",
        permissao: "Relatorio006ContasAPagar",
    },
    Relatorio007CartaoPonto: {
        urlVisualizacao: "relatorio/timecard",
        urlCriacao: "relatorios/timecard",
        permissao: "Relatorio007CartaoPonto",
    },
    Relatorio008Comparativo: {
        urlVisualizacao: "relatorio/comparativo",
        urlCriacao: "relatorios/comparativo",
        permissao: "Relatorio008Comparativo",
    },
    Relatorio009AcumuladoRede: {
        urlVisualizacao: "relatorio/acumuladoRede",
        urlCriacao: "relatorios/acumuladoRede",
        permissao: "Relatorio009AcumuladoRede",
    },
    Relatorio010AnalistasAncorasAntecipacoes: {
        urlVisualizacao: "relatorio/ancoraAntecipacoes",
        urlCriacao: "relatorio/ancoraAntecipacoes",
        permissao: "Relatorio010AnalistasAncorasAntecipacoes",
    },
    RelatoriosDinamicos: {
        urlVisualizacao: "relatorio/dinamicos",
        urlCriacao: "relatorio/dinamicos",
        permissao: "RelatoriosDinamicos",
    },
    "FechamentoMensal": {
        urlVisualizacao: "relatorio/fechamentoMensal",
        urlCriacao: "relatorio/fechamentoMensal",
        permissao: "AncoraFechamentoMeses",
    },
    ImportacoesTitulosExecucoes: {
        urlVisualizacao: "importacoes-titulos-execucoes",
        urlCriacao: "importacoes-titulos-execucoes",
        permissao: "ImportacoesTitulosExecucoes",
    },
    ErpsApisControlesBaixasTitulosAntecipados: {
        urlVisualizacao: "erps-controles-baixas-titulos-antecipados",
        urlCriacao: "erps-controles-baixas-titulos-antecipados",
        permissao: "ErpsApisControlesBaixasTitulosAntecipados",
    }
};

  export const urlsControle = [
    '/app/home',
    '/app/relatorios',
    '/app/cadastros',
    '#',
    '#',
    '#'
  ]